<template>
  <div>
    <div class="goTop" v-show="scrollTop > 0" @click="backtop">
      <img src="../../assets/index/gotop.png" />
    </div>
    <!-- 导航栏 -->
    <ul class="pro_nav clear">
      <li
        v-for="(item, findex) in ftopNav"
        :key="findex"
        @click="routerGo(item)"
      >
        <img :src="findex == fidx ? item.imgSel : item.img" />
        <div class="pro_txt" :class="{ proOn: findex == fidx }">
          {{ item.txt }}
        </div>
      </li>
    </ul>
    <div class="footer">
      <el-row class="clear">
        <div class="footer_list">
          <el-col :span="18">
            <ul class="footer_nav">
              <el-row>
                <el-col :span="4" v-for="(o, idx) in footerList" :key="idx">
                  <li>
                    <dl>
                      <dt>
                        <img
                          :style="{ width: o.width, left: o.left }"
                          :src="o.img"
                        />{{ o.title }}
                      </dt>
                      <dd
                        v-for="(child, index) in o.ddname"
                        :key="index"
                        @click="routerGo(child)"
                      >
                        {{ child.name }}
                      </dd>
                    </dl>
                  </li>
                </el-col>
              </el-row>
            </ul>
          </el-col>
          <el-col :span="6">
            <div class="imgShow">
              <img src="../../assets/index/erweima.png" />
              <div class="scence">扫一扫关注</div>
              <div class="gwTxt">珠江涂料官方公众号</div>
            </div>
          </el-col>
        </div>
      </el-row>
      <div class="mainBody">
        <div id="divLoginpanelVer" class="bizmail_loginpanel">
          <div class="bizmail_LoginBox">
            <form
              name="form1"
              action="https://exmail.qq.com/cgi-bin/login"
              target="_blank"
              method="post"
              onsubmit="return checkInput()"
            >
              <input type="hidden" name="firstlogin" value="false" />
              <input type="hidden" name="errtemplate" value="dm_loginpage" />
              <input type="hidden" name="aliastype" value="other" />
              <input type="hidden" name="dmtype" value="bizmail" />
              <input type="hidden" name="p" value="" />
              <div class="form1con">
                <div class="bizmail_column_tit">企业邮箱登录</div>
                <div class="bizmail_column">
                  <div class="bizmail_column_span">
                    <img src="../../assets/index/zhico.png" />
                    <span>账号:</span>
                  </div>
                  <div class="bizmail_inputArea">
                    <input
                      type="text"
                      autocomplete="off"
                      onkeyup="this.value=this.value.replace(/[, ]/g,'')"
                      name="uin"
                      class="text"
                      value=""
                    />@
                    <span>gdzjhg.com</span>
                    <input type="hidden" name="domain" value="gdzjhg.com" />
                  </div>
                </div>
                <div class="bizmail_column marginL75">
                  <div class="bizmail_column_span">
                    <img src="../../assets/index/mmico.png" />
                    <span>密码:</span>
                  </div>
                  <div class="bizmail_inputArea">
                    <input
                      type="password"
                      name="pwd"
                      autocomplete="off"
                      class="text"
                      value=""
                    />
                  </div>
                </div>
                <div class="bizmail_SubmitArea">
                  <input
                    type="submit"
                    class=""
                    name=""
                    style="width:66px;"
                    value="登录"
                  />
                  <a
                    href="https://exmail.qq.com/cgi-bin/readtemplate?check=false&t=bizmail_orz"
                    target="_blank"
                    rel="noopener noreferrer"
                    >忘记密码?</a
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="beian">
        Copyright 版权所有 粤ICP备20070956号-1
        <div class="FriendlyLinks">
          友情链接：<a href="https://www.giihg.com/" target="_blank"
            >广州工控</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.footer_list {
  width: 1200px;
  margin: 0 auto;
}

.footer {
  border-top: 4px solid #044cff;
  background: #dedede;
}

.footer_nav {
  width: 1002px;
  line-height: 36px;
  /* font-size: 1.0417vw; */
  color: #666666;
  text-align: left;
  margin-top: 40px;

  li {
    padding-left: 40px;
    position: relative;

    dt {
      line-height: 40px;

      img {
        position: absolute;
        left: 10px;
        height: 23px;
        top: 7px;
        cursor: pointer;
      }

      font-size: 18px;
      color: #333333;
      font-weight: 400;
    }

    dd {
      font-size: 16px;
      cursor: pointer;
    }
  }
}

.imgShow {
  width: 180px;
  font-size: 16px;
  /* font-weight: bold; */
  text-align: right;
  color: #333;
  float: right;
  margin-top: 52px;
  text-align: center;

  img {
    width: 100%;
  }

  .scence {
    text-align: center;
    margin: 0vw 0 0.5208vw 0;
  }

  .gwTxt {
    /* padding-right: 0.5208vw; */
  }
}

.beian {
  font-size: 16px;
  color: #666666;
  text-align: center;
  padding: 50px 0;
  position: relative;
  .FriendlyLinks {
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-left: -496px;
    a {
      color: #333333;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.pro_nav {
  width: 1200px;
  margin: 120px auto 67px auto;
  text-align: center;

  li {
    float: left;
    width: 274px;
    height: 77px;
    box-sizing: border-box;
    border-right: 0.1042vw dashed #436cd1;
    cursor: pointer;

    .pro_txt {
      font-size: 18px;
      color: #b5b5b5;

      &.proOn {
        color: #0a308f;
      }
    }

    img {
      position: relative;
      top: -17px;
      width: 48px;
    }

    &:nth-child(1) {
      text-align: left;
      width: 195px;

      img {
        left: 12px;
      }
    }

    &:nth-child(5) {
      text-align: right;
      border: none;
      width: 183px;

      img {
        right: 12px;
      }
    }
  }
}

.goTop {
  width: 60px;
  position: fixed;
  bottom: 100px;
  right: 50px;
  z-index: 20000;
  cursor: pointer;

  img {
    width: 100%;
  }
}

.mainBody {
  width: 1200px;
  margin: 0 auto;
}
.form1con {
  height: 60px;
  line-height: 60px;
  width: 100%;
  text-align: left;
  padding: 0 35px;
  margin-top: 20px;
  border-top: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
  .bizmail_column {
    display: inline-block;
  }
  .bizmail_SubmitArea {
    display: inline-block;
  }
  .bizmail_inputArea {
    input {
      background: #fff;
      border: none;
      outline: 0;
      height: 32px;
      line-height: 32px;
      padding-left: 5px;
      border-radius: 5px;
      color: #333333;
      font-size: 16px;
      margin-right: 5px;
      margin-left: 5px;
      width: 200px;
    }
  }
  .bizmail_column_span {
    color: #0a308f;
    img {
      margin-right: 10px;
    }
  }
}
.bizmail_column_span,
.bizmail_inputArea {
  display: inline-block;
}
.bizmail_column_tit {
  color: #333333;
  font-size: 18px;
  display: inline-block;
  margin-right: 50px;
}
.marginL75 {
  margin-left: 75px;
}
.bizmail_SubmitArea {
  input {
    width: 80px;
    height: 32px;
    line-height: 32px;
    background-color: #0a308f;
    border-radius: 5px;
    border: none;
    color: #fff;
    font-size: 16px;
    margin-left: 30px;
    margin-right: 30px;
  }
  a {
    color: #0a308f;
    font-size: 16px;
    text-decoration: underline;
  }
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  box-shadow: 0 0 0 60px #eee inset;
  -webkit-text-fill-color: #ffffff;
}
</style>

<script>
export default {
  data() {
    return {
      fidx: 0,
      scrollTop: 0,
      routerName: "", //路由名称
      ftopNav: [
        {
          img: require("../../assets/index/proico1.png"),
          imgSel: require("../../assets/index/proico1on.png"),
          txt: "研发实力",
          url: "/enterZT/research"
        },
        {
          img: require("../../assets/index/proico2.png"),
          imgSel: require("../../assets/index/proico2on.png"),
          txt: "产品中心",
          url: "/product"
        },
        {
          img: require("../../assets/index/proico3.png"),
          imgSel: require("../../assets/index/proico3on.png"),
          txt: "品牌家族",
          url: "/houses"
        },
        {
          img: require("../../assets/index/proico4.png"),
          imgSel: require("../../assets/index/proico4on.png"),
          txt: "技术支持",
          url: "/technology"
        },
        {
          img: require("../../assets/index/proico5.png"),
          imgSel: require("../../assets/index/proico5on.png"),
          txt: "销售网络",
          url: "/enterZT/network"
        }
      ],
      footerList: [
        {
          title: "走进珠涂",
          img: require("../../assets/index/icon1.png"),
          // left: '0',
          ddname: [
            { name: "企业简介", url: "/enterZT" },
            { name: "发展历程", url: "/enterZT/event" },
            // { name: "新闻动态", url: "/enterZT/news/1" },
            { name: "研发实力", url: "/enterZT/research" },
            { name: "工程案例", url: "/enterZT/project" },
            { name: "销售网络", url: "/enterZT/network" }
          ]
        },
        {
          title: "品牌家族",
          // left: '0',
          img: require("../../assets/index/icon2.png"),
          ddname: [
            { name: "电视塔", url: "/houses" },
            { name: "青竹", url: "/houses/houses2" },
            { name: "青松", url: "/houses/houses3" },
            { name: "南方牌", url: "/houses/houses4/1" },
            { name: "东风施能", url: "/houses/houses4/0" }
          ]
        },
        {
          title: "产品系列",

          // left: '0',
          img: require("../../assets/index/icon3.png"),
          ddname: [
            { name: "品牌分类", url: "/product", id: 0 },
            { name: "应用分类", url: "/product", id: 1 },
            { name: "水性树脂", url: "/product/sxshoplist", id: 2 }
          ]
        },
        {
          title: "技术支持",

          // left: '0',
          img: require("../../assets/index/icon4.png"),
          ddname: [
            { name: "服务政策", url: "/technology", id: 0 },
            { name: "常见问题", url: "/technology", id: 1 },
            { name: "售后服务", url: "/technology", id: 2 }
          ]
        },
        {
          title: "新闻资讯",

          // left: '0',
          img: require("../../assets/index/icon5.png"),
          ddname: [
            { name: "企业新闻", url: "/news", id: 0 },
            { name: "党建要闻", url: "/news", id: 1 }
          ]
        },
        {
          title: "联系我们",

          // left: '0',
          img: require("../../assets/index/icon6.png"),
          ddname: [{ name: "联系方式", url: "/concact" }]
        }
      ]
    };
  },
  created() {
    this.routerName = window.sessionStorage.getItem("routerName");
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    routerGo(item) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({ path: item.url, query: { id: item.id } });
    },
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  },
  watch: {
    $route(to, from) {
      console.log("底部监听路由", to.name);
      switch (to.name) {
        case "research":
          this.fidx = 0;
          break;
        case "shoplist":
          this.fidx = 1;
          break;
        case "houses01":
          this.fidx = 2;
          break;
        case "houses2":
          this.fidx = 2;
          break;
        case "houses3":
          this.fidx = 2;
          break;
        case "houses4":
          this.fidx = 2;
          break;
        case "technology":
          this.fidx = 3;
          break;
        case "network":
          this.fidx = 4;
          this.$store.state.fidx = 3;
          break;
        default:
          this.fidx = 5;
      }
    }
  }
};
</script>
